import { Inject, Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavItem } from '../interfaces/nav-item';
import { ITab } from './../interfaces/tab.model';


@Injectable({
  providedIn: 'root',
})

export class TabService {
  tabs: ITab[] = [];
  tabOptions: ITab[] = [];
  public activeTabIndex = new BehaviorSubject<number>(-1);

  constructor(/* @Inject("navItens") private navItens: NavItem[]*/) {
    //this.findRecursive(this.navItens);
  }

  findRecursive(navItem:NavItem[] ){
    navItem.forEach(x=>{

        // menu que o usuario nao pode ver tambem nao pode virar opcao de aba
        if ( x.visible === false ){
            return;
        }

        if ( x.children ){
            this.findRecursive(x.children)

        }else{
            if ( x.route!=null){
                this.tabOptions.push({name:'menu.'+x.id, url:x.route, iconName:x.iconName, svgIconName:x.svgIconName});
            }
        }

    });

  }

  addTab(navItem: NavItem) {

    if (!navItem.route || navItem.route.trim() === '') {      
      return;
    }

    const tab = this.getTabOptionByUrl(navItem.route);
    
    
    if (!tab) {      
      
      const fallbackTab: ITab = {
        name:  'menu.' + navItem.id,
        url: navItem.route,
        iconName: navItem.iconName,
        svgIconName: navItem.svgIconName
      };
      this.tabs.push(fallbackTab);
      localStorage.setItem('tabs',JSON.stringify(this.tabs));
      return;
    }
    
    
    if (!tab.url || tab.url.trim() === '') {
      console.error('❌ TabService.addTab: Tab encontrada mas sem URL válida:', tab);
      return;
    }
    
    this.tabs.push(tab);
      localStorage.setItem('tabs',JSON.stringify(this.tabs));
      setTimeout(()=>{
      });
  }
   
  getTabOptionByUrl(url: string): ITab {
    return this.tabOptions.find(tab => {
        return tab.url === url
    });
  }
   
  deleteTab(index: number) {
    this.tabs.splice(index, 1);
    localStorage.setItem('tabs',JSON.stringify(this.tabs));
  }

  loadTabs(){
    if ( localStorage.getItem('tabs')!=null ){
      let loadedTabs: ITab[] = JSON.parse(localStorage.getItem('tabs'));
      
      // ✅ Filtrar tabs inválidas (sem url)
      this.tabs = loadedTabs.filter(tab => {
        if (!tab || !tab.url || tab.url.trim() === '') {
          console.warn('⚠️ TabService.loadTabs: Tab inválida removida do localStorage:', tab);
          return false;
        }
        return true;
      });
      
      // ✅ Salvar tabs limpas de volta no localStorage
      if (this.tabs.length !== loadedTabs.length) {
        console.log(`🧹 TabService.loadTabs: ${loadedTabs.length - this.tabs.length} tabs inválidas removidas`);
        localStorage.setItem('tabs', JSON.stringify(this.tabs));
      }
    }
  }
}